import type { App } from "vue";
import {
  AuditLogDataSourceImpl,
  auditLogDataSourceKey,
} from "./data/datasources/audit_log_datasource";

export function initAuditLogModule(app: App) {
  app.provide(auditLogDataSourceKey, new AuditLogDataSourceImpl());
}
